import { HttpInterceptorFn } from '@angular/common/http';
import { API_CONFIG } from '../config/api.config';

/**
 * Interceptor para prevenir caché en peticiones HTTP
 * Agrega un query parameter con timestamp para forzar peticiones frescas
 * (No usamos headers Cache-Control porque causan problemas CORS)
 */
export const cacheControlInterceptor: HttpInterceptorFn = (req, next) => {
  // Solo aplicar a peticiones de nuestra API
  const isOurApi = req.url.includes(API_CONFIG.baseUrl);
  
  if (!isOurApi) {
    return next(req);
  }

  // Agregar timestamp como query parameter para evitar caché
  // Usamos string para soportar URLs relativas (proxy en desarrollo) y absolutas (producción)
  const separator = req.url.includes('?') ? '&' : '?';
  const urlWithTimestamp = `${req.url}${separator}_t=${Date.now()}`;

  console.log('🕐 [CacheInterceptor] URL con timestamp:', urlWithTimestamp);

  const clonedRequest = req.clone({
    url: urlWithTimestamp
  });

  return next(clonedRequest);
};
